import { BaseService } from "./base.service";

export class SchoolService extends BaseService {
  public async getStudentAttendances(
    meetingId: string,
    accessToken: string | null
  ): Promise<any> {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        ...(accessToken && { Authorization: `Bearer ${accessToken}` }),
      },
    };

    const response = await fetch(
      `${this.getEndPoint()}/school/GetStudentAttendances?meetingId=${meetingId}`,
      requestOptions
    );
    return await response.json();
  }

  public async validate(meetingId: string, code: string): Promise<any> {
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ meetingId: meetingId, securityPin: code }),
    };
    const response = await fetch(
      `${this.getEndPoint()}/school/validate`,
      requestOptions
    );
    if (response.ok) {
      if (response.status == 200) {
        const data = await response.json();
        if (data.accessToken) {
          return { success: true, accessToken: data.accessToken };
        } else {
          throw new Error("No access token received from the backend.");
        }
      } else {
        return await response.json();
      }
    } else {
      throw new Error("Unexpected error occurred");
    }
  }
}
